import { Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class Tweener {
  static Initialize(game) {
    this.game = game;

    // this.tweens = new Map();

    // game.state.onStateChange.add(() => {this.eh_Statechanged();});
  }

  static To(object, values, time, ease = Phaser.Math.Easing.None) {
    const tween = Tweens.addTween(object, time, values, ease);
    return tween;
  }

  static Kill(object) {
    object.scene.tweens.killTweensOf(object);
  }

  static TweenTint(object, tint, duration) {
    return Tweens.addTintTween(object, tint, duration);
  }
}